/* import __COLOCATED_TEMPLATE__ from './direct-engaged-conversation-rating.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { units } from 'embercom/lib/reporting/flexible/formatters';
import {
  DIRECT_TO_HUMAN_AMAZING_GREAT_CONVERSATION_RATING,
  DIRECT_TO_HUMAN_CONVERSATION_RATING_ALL,
} from 'embercom/lib/reporting/csf-queries';
import { getTimeConfig } from 'embercom/lib/reporting/csf-query-helper';
import { buildDataConfigWithComparisons } from 'embercom/lib/reporting/comparison-data-config';
import { improvementDirections } from 'embercom/components/reporting/element/summary-comparison';

const DIRECT_TO_HUMAN_SUPPORT_CONVERSATION_RATING_NUMERATOR =
  'direct-to-human-support-conversation-rating-numerator';

export default class DirectEngagedConversationRating extends Component {
  get viewConfig() {
    return {
      formatUnit: { unit: units.percent },
      counter: {
        [DIRECT_TO_HUMAN_SUPPORT_CONVERSATION_RATING_NUMERATOR]: {
          improvementDirection: improvementDirections.INCREASING,
        },
      },
    };
  }

  get time() {
    return getTimeConfig({ range: this.args.range });
  }

  get dataConfig() {
    return buildDataConfigWithComparisons(
      {
        series: [
          {
            name: DIRECT_TO_HUMAN_SUPPORT_CONVERSATION_RATING_NUMERATOR,
            ...DIRECT_TO_HUMAN_AMAZING_GREAT_CONVERSATION_RATING,
            time: this.time,
          },
          {
            name: 'direct-to-human-support-conversation-rating-denominator',
            ...DIRECT_TO_HUMAN_CONVERSATION_RATING_ALL,
            time: this.time,
          },
        ],
      },
      this.args.range,
    );
  }
}
